export const TestCampaignStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
}

export const TestCampaignStage = {
  CAMPAIGN: 'CAMPAIGN',
  ADSET: 'ADSET',
  AD: 'AD',
}

export function isTerminalState(status) {
  if (!status) return false
  return status === TestCampaignStatus.SUCCESS || status === TestCampaignStatus.FAILURE
}

/**
 * Returns true when there is at least one ACTIVE Google Ads account with billing enabled.
 * @param {Array} assets - connected Google PartnerIntegration assets
 */
export function canEnableGoogleTestCampaign(assets) {
  return assets.some(
    (a) =>
      a.is_enabled &&
      a.extra_data?.invitation_status === 'ACTIVE' &&
      a.extra_data?.account_status === 'enabled',
  )
}

/**
 * Return the ad accounts eligible to run a test campaign.
 */
export function getActiveAdAccounts(assets) {
  return assets.filter(
    (a) =>
      a.is_enabled &&
      a.extra_data?.invitation_status === 'ACTIVE' &&
      a.extra_data?.account_status === 'enabled',
  )
}

/**
 * Return conversion actions linked to an ad account (stored in asset.pixels).
 */
export function getConversionsForAccount(adAccount) {
  return adAccount?.pixels ?? []
}

/**
 * Build the Google Ads dashboard URL for a customer/campaign.
 * @param {string} customerId - raw customer ID (may include dashes)
 */
export function getGoogleAdsDashboardUrl(customerId) {
  const cleanId = String(customerId).replace(/-/g, '')
  return `https://ads.google.com/aw/campaigns?ocid=${cleanId}`
}

export function getPollingInterval(elapsedMs) {
  if (elapsedMs < 60000) return 5000
  if (elapsedMs < 180000) return 10000
  if (elapsedMs < 360000) return 15000
  return 30000
}

export function getStageOrder(stage) {
  const order = {
    [TestCampaignStage.CAMPAIGN]: 1,
    [TestCampaignStage.ADSET]: 2,
    [TestCampaignStage.AD]: 3,
  }
  return order[stage] || 0
}
